/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSessionsMosaicsResponseOkDto } from '../models/GetSessionsMosaicsResponseOkDto';
import type { limit } from '../models/limit';
import type { MosaicStatus2 } from '../models/MosaicStatus2';
import type { offset } from '../models/offset';
import type { PostSessionsMosaicResponseOkDto } from '../models/PostSessionsMosaicResponseOkDto';
import type { PostSessionsMosaicsSessionDestinationStreamsRequestDto } from '../models/PostSessionsMosaicsSessionDestinationStreamsRequestDto';
import type { session_decryption_key } from '../models/session_decryption_key';
import type { session_service_ip } from '../models/session_service_ip';
import type { session_service_port } from '../models/session_service_port';
import type { session_service_protocol } from '../models/session_service_protocol';
import type { sortOder } from '../models/sortOder';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MosaicsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Route called to start receiving a mosaic stream.
     * Route called to start receiving a mosaic stream.
     * @returns any Connection informations.
     * @throws ApiError
     */
    public postSessionsMosaicsSessionDestinationStreams({
        requestBody,
    }: {
        requestBody: PostSessionsMosaicsSessionDestinationStreamsRequestDto,
    }): CancelablePromise<{
        session_destination_service_ip: session_service_ip;
        session_destination_service_protocol?: session_service_protocol;
        session_destination_service_port?: session_service_port;
        session_decryption_key?: session_decryption_key;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/mosaics/destination',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * Route called to start producing a mosaic stream by combining multiple other streaming sessions.
     * Route called to start producing a mosaic stream by combining multiple other streaming sessions.
     * @returns PostSessionsMosaicResponseOkDto Mosaic's informations.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public postMosaic({
        requestBody,
    }: {
        requestBody: {
            /**
             * Tableau des tags de production associés à la mosaic.
             */
            tags: Array<string>;
            /**
             * breve description de la mosaic permettant de la differencier d'autres
             */
            description: string;
            /**
             * Adresse IP/url de destination du flux à envoyer
             */
            output_url: string;
            /**
             * Port de destination pour la vidéo du flux à envoyer
             */
            output_video_port: number;
        },
    }): CancelablePromise<PostSessionsMosaicResponseOkDto | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/mosaics',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                409: `Conflict`,
            },
        });
    }
    /**
     * @returns GetSessionsMosaicsResponseOkDto
     * @throws ApiError
     */
    public sessionsControllerGetMosaicsList({
        tags,
        mosaicStatus,
        limit,
        offset,
        sort,
    }: {
        /**
         * Array of tags
         */
        tags?: Array<string>,
        mosaicStatus?: MosaicStatus2,
        limit?: limit,
        offset?: offset,
        sort?: {
            id?: sortOder;
        },
    }): CancelablePromise<GetSessionsMosaicsResponseOkDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/mosaics',
            query: {
                'tags': tags,
                'mosaic_status': mosaicStatus,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
            errors: {
                500: `Internal error.`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public sessionsControllerPostMosaicStop({
        id,
    }: {
        /**
         * Id of the Mosaic production to stop.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/mosaics/{id}/stop',
            path: {
                'id': id,
            },
            errors: {
                500: `Internal error.`,
            },
        });
    }
}
